<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="width: 90%;margin-top: 2%;">
      <div style="overflow-x: hidden;overflow-y: auto;margin-left: 5%; height: 98%;">
        <div id="report" style="margin-top: 2%;"
              v-loading="loading">
          <div class="drawerDiv">
            <div style="width: 80%; height: 150px;">
              <img :src="Global.imgip + '/resources/images/reportLogo/shiyan.jpg'"
                  width="620" />
            </div>
            <h3 style="text-align: center;">实验报告</h3>
            <el-row>
              <el-col :span="24">
                <div><span>实验名称：</span><span style="color: black; text-decoration: underline; ">{{Experiment.expName}}</span></div>
              </el-col>
              <!-- <el-col :span="24">
                <div>
                  <span>小组名称：</span>
                  <span style="color: black;  text-decoration: underline;margin-right: 100px;">{{Experiment.groupName}}</span>
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总分：</span>
                  <span style="color: red;  text-decoration: underline; "> {{Experiment.totalScore}}分</span>
                </div>
              </el-col> -->
              <el-col :span="24">
                <span>班级：</span>
                <span style="color: black;  text-decoration: underline;">{{Experiment.className}}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学号：</span>
                <span style="color: black;  text-decoration: underline; ">{{Experiment.studenNo}}</span>
              </el-col>
              <el-col :span="24">
                <span>指导老师：</span>
                <span style="color: black;  text-decoration: underline;">{{Experiment.teacherName}}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;实验时间：</span>
                <span style="color: black;  text-decoration: underline; ">{{filter.formatDate(Experiment.expTime,'yyyy-M-d')}}</span>
              </el-col>
              <el-col :span="24">
                <span> 操作回合:</span>
                <span style="color: black;  text-decoration: underline; ">{{ Experiment.round}}</span>
              </el-col>
              <el-col :span="24">
                <span style="font-weight: bold;font-size: 16px;">【总分】：</span>
                <span style="color: red; text-decoration: underline; ">{{Experiment.totalScore}}分</span>
              </el-col>
              <el-col :span="24">
                <span style="font-weight: bold;font-size: 16px;">【预习得分】：</span>
                <span style="color: red; text-decoration: underline; ">{{Experiment.operationScore}}分</span>（满分{{Experiment.previewScoreRate}}分）
              </el-col>
              <el-col :span="24">
                <span style="font-weight: bold;font-size: 16px;">【操作得分】：</span>
                <span style="color: red; text-decoration: underline; ">{{Experiment.score}}分</span>（满分{{Experiment.expOperationScoreRate}}分）
              </el-col>
              <el-col :span="24">
                <span style="font-weight: bold;font-size: 16px;">【利润率得分】：</span>
                <span style="color: red; text-decoration: underline; ">{{Experiment.profitScore}}分</span>（满分{{Experiment.expDataRate}}分）
              </el-col>
              <el-col :span="24">
                <span style="font-weight: bold;font-size: 16px;">【教师评分】：</span>
                <span style="color: red; text-decoration: underline; ">{{Experiment.teacherRating}}分</span>（满分{{Experiment.teacherScoreRate}}分）
              </el-col>
              <!-- <el-col :span="24">
                <span>价格准确性(满分100分)：</span>
                <span style="color: red;  text-decoration: underline;">{{Experiment.priceSatisfaction}}分</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;营销准确性(满分100分)：</span>
                <span style="color: red;  text-decoration: underline; ">{{Experiment.marketingCapacity}}分</span>
              </el-col>
              <el-col :span="24">
                <span>市场相关性(满分100分)：</span>
                <span style="color: red;  text-decoration: underline;">{{Experiment.marketRelevance}}分</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务满意性(满分100分)：</span>
                <span style="color: red;  text-decoration: underline; ">{{Experiment.serviceSatisfaction}}分</span>
              </el-col>
              <el-col :span="24">
                <span>预算合理性(满分100分)：</span>
                <span style="color: red;  text-decoration: underline;">{{Experiment.budgetAccuracy}}分</span>
              </el-col> -->
              <el-col :span="24">
                <h3>【实验目的】</h3>
                <p>1、了解会展运营基本知识和概念体系。</p>
                <p>2、理解整个会展从开始到结束的整个流程‘</p>
                <p>3、掌握会展策划及市场分析的基本策略</p>
              </el-col>
              <el-col :span="24">
                <h3>【实验仪器】</h3>
                <p>1、后台软、硬件：服务器一台，用于软件运行环境搭建。</p>
                <p>2、前台软硬件：安装谷歌浏览器(v63.0.3239.84+)或火狐浏览器(v8.0+)主机一台。</p>
              </el-col>
              <el-col :span="24">
                <h3>【实验内容】</h3>
                <span>&nbsp;&nbsp;登录进入实验平台，进行实验选择及项目引导观看学习，完成学习后方可进入实验。实验操作步骤涉及五个部分，对市场数据的分析、整体的规划的策划、整体运行时的数据分析，进行仿真模拟。操作完成后，系统自动根据学生操作生成相应报表，由学生完成策划效果的实验报告，由系统评分、教师评阅给出实验成绩。</span>
              </el-col>
            </el-row>
            <h4>1.展会基本信息</h4>
            <div>
              <p>时间：<span class="span">{{ManagementData.exhibitionDate}}</span></p>
              <p>场地：<span class="span">{{ManagementData.address}}</span></p>
              <p>展会规模：<span class="span">{{ManagementData.siteSize}}</span>平方米</p>
              <p>展会数量：大展位：<span class="span">{{ManagementData.largeBoothNumber}}</span>,中展位：<span class="span">{{ManagementData.mediumBoothNumber}}</span>,小展位：<span class="span">{{ManagementData.smallBoothNumber}}</span></p>
              <p>展会价格：大展位：<span class="span">{{ManagementData.largeBoothAreaCost}}</span>元,中展位：<span class="span">{{ManagementData.mediumBoothAreaCost}}</span>元,小展位：<span class="span">{{ManagementData.smallBoothAreaCost}}</span>元</p>
              <p>门票费用：<span class="span">{{ManagementData.admissionFee}}</span>元/位</p>
              <p>参展企业数量：<span class="span">{{ManagementData.companyNumber}}</span>家</p>
              <p>参展观众数量：<span class="span">{{ManagementData.audienceNumber}}</span>人</p>
              <p></p>
            </div>
            <div id="columnChart_chartSG"
                  v-if="exportLing"></div>
            <div>
              <h4>2.会展营销</h4>
              本次展会使用了<span class="span"
                    v-for="item in MarketingData.platformList"
                    :key="item.id">{{item}},</span>进行信息发布花费<span class="span">{{MarketingData.platformCost}}</span>元，
              邀约了<span class="span"
                    v-for="item in MarketingData.mediaList"
                    :key="item.id">{{item}}，</span>媒体。
              邀请了<span class="span">{{MarketingData.speechExpertCount}}</span>位专家,
              <span class="span">{{MarketingData.speechEnterpriseCount}}</span>家企业进行主题演讲，展位招商了
              <span class="span">{{MarketingData.boothEnterpriseCount}}</span>家企业，广告招商招了<span class="span">{{MarketingData.advertEnterpriseCount}}</span>
              家企业，已有<span class="span">{{MarketingData.receipAgreeWithCount}}</span>回执愿意参加，<span class="span">{{MarketingData.receipRefuseCount}}</span>拒绝参加
            </div>
            <div id="columnChart_chartSG1"
                  v-if="exportLing"></div>
            <div>
              <h4>3.数据分析</h4>
              <label v-if="DataAnalysis.purchaseEnterpriseType==''">未购买行业的营销数据，</label>
              <label v-if="DataAnalysis.purchaseEnterpriseType!=''"> 购买了<span class="span">{{DataAnalysis.purchaseEnterpriseType}}</span>行业的营销数据，</label>
              在过程分析中观察到共有<span class="span">{{DataAnalysis.signIn}}</span>条
              签到数据，其中有<span class="span">{{DataAnalysis.exhibitor}}</span>家参展商进行了签到，
              <span class="span"> {{DataAnalysis.expert}}</span>位专家/领导进行了签到,<span class="span">{{ServicesData.audienceCount}}</span>位观众进行了签到。，安排了
              <span class="span">{{DataAnalysis.stay}}</span> 位专家/领导入住了酒店。共有<span class="span">{{DataAnalysis.audience}}</span>位参展观众,<span class="span">{{ DataAnalysis.exhibitors }}</span>家参展企业。
              通过反馈数据查看出参展人员共<span class="span">{{DataAnalysis.personnelSatisfaction}}</span>位对本次展会满意，
              <span class="span">{{DataAnalysis.personnelZhongke}}</span>位对本次展会保持中肯，
              <span class="span">{{DataAnalysis.personnelDissatisfaction}}</span>位对本次展会感觉不满意
              参展商共<span class="span">{{DataAnalysis.exhibitorSatisfaction}}</span>位对本次展会满意。
              <span class="span">{{DataAnalysis.exhibitorZhongke}}</span>位对本次展会保持中肯，
              <span class="span">{{DataAnalysis.exhibitorDissatisfied}}</span>位对本次展会感觉不满意。若再次举办类似展会有
              <span class="span">{{DataAnalysis.personnelWilling}}</span>位愿意参加，
              <span class="span">{{DataAnalysis.personnelConsider}}</span>位有待考虑是否参加，
              <span class="span">{{DataAnalysis.personnelReluctant}}</span>位不愿意再次参加。
            </div>
            <div id="columnChart_chartSG2"
                  v-if="exportLing"></div>
            <div>
              <h4>4.会展服务</h4>
              本次展商共有<span class="span">{{ServicesData.enterpriseCount}}</span>家参展企业签到，<span class="span">{{ServicesData.expertCount}}</span>位专家进行了签到，<span class="span">{{ServicesData.audienceCount}}</span>位观众进行了签到。
              <span class="span">{{ServicesData.arrangedCount}}</span>位专家安排了酒店，<span class="span">{{ServicesData.noArrangedCount}}</span>位专家未安排酒店。
              <span v-for="item in ServicesData.restaurantList"
                    :key="item">安排了<span class="span">{{Global.RestaurantTypeList.filter(c=>c.id==item)[0].name}}</span>。</span>
              安排了<span class="span">{{ServicesData.carTripCount}}</span>车辆进行接送专家,有<span class="span">{{ServicesData.noCarTripCount}}</span>位专家未安排车辆。在展会执行过程中遇到了<span class="span">{{ServicesData.emergenciesCount}}</span>次突发情况。
              开展了<span class="span">{{ServicesData.activityCount}}</span>次活动，其策划的文案为<span class="span">{{ServicesData.copywriting}}</span>。<span v-if="ServicesData.isSurvey">对用户进行了反馈调查</span>
            </div>
            <div id="columnChart_chartSG3"
                  v-if="exportLing"></div>
            <div>
              <h4>5.财务管理</h4>
              总结内容：本次会展在策划时共提交了<span class="span">{{ Summary.budgetCount }}</span>次预算,
              其中<span class="span">{{ Summary.budgetRefuse }}</span>次未通过审批,
              <span class="span">{{ Summary.budgetApproved }}</span>次通过审批,
              本次展会预算费用为:设计费用为<span class="span">{{ Summary.designCost }}</span>元,
              专家费用的预算为<span class="span">{{ Summary.expertFees }}</span>元,
              宣传推广费用为<span class="span">{{ Summary.promotionExpenses }}</span>元,
              招商费用为<span class="span">{{ Summary.attractInvestment }}</span>元,
              媒体费用为<span class="span">{{ Summary.mediaCost }}</span>元,
              场地租赁费用<span class="span">{{ Summary.venueCost }}</span>元,
              其他费用<span class="span">{{ Summary.otherCost }}</span>元。
              本次展会实际总支出为<span class="span">{{ Summary.totalExpenditure }}</span>元,
              本次展会实际总收入为<span class="span">{{ Summary.totalIncome }}</span>元,
              设计费用为<span class="span">{{ Summary.designCosts }}</span>元,
              人员费用为<span class="span">{{ Summary.employeeCost }}</span>元,
              专家费用为<span class="span">{{ Summary.expertCost }}</span>元,
              营销费用为<span class="span">{{ Summary.marketingCost }}</span>元,
              招商费用为<span class="span">{{ Summary.attractInvestmentCost }}</span>元,
              媒体费用为<span class="span">{{ Summary.mediaCosts }}</span>元,
              场馆费用为<span class="span">{{ Summary.venueCosts }}</span>元,
              会场费用为<span class="span">{{ Summary.venueFees }}</span>元,
              茶点费用为<span class="span">{{ Summary.teaCost }}</span>元,
              正餐费用为<span class="span">{{ Summary.dinCost }}</span>元,
              活动费用为<span class="span">{{ Summary.activityCost }}</span>元,
              秩序维护花费为<span class="span">{{ Summary.orderMaintenance }}元,</span>
              企业数据购买花费为<span class="span">{{ Summary.enterprisePurchaseCost }}元,</span>
              门票收入为<span class="span">{{ Summary.ticketIncome }}</span>元,
              主题演讲收入为<span class="span">{{ Summary.keynoteIncome }}</span>元。
              广告收入为<span class="span">{{ Summary.advertisingIncome }}</span>元,
              大展位收入为<span class="span">{{ Summary.largeBoothIncome }}</span>元,
              小展位收入为<span class="span">{{ Summary.smallBoothIncome }}</span>元,
              中展位收入为<span class="span">{{ Summary.mediumBoothIncome }}</span>元。
              本次展会共开具了<span class="span">{{ Summary.invoiceCount }}</span>张发票,
              其中专票<span class="span">{{ Summary.specialTicket }}</span>张,
              普票<span class="span">{{ Summary.universalTicket }}</span>张。
            </div>
            <div id="columnChart_chartSG4"
                  v-if="exportLing"></div>

          </div>
          <div>
            <span>实验总结</span>
            <el-input v-model="textarea"
                      :rows="2"
                      type="textarea"
                      placeholder="实验总结" />
          </div>
        </div>
        <div style="text-align: center;">
          <el-button type="primary"
                      @click="ExportReport">导出报告</el-button>
          <div style=" display: inline-block;margin-left: 10px;">
            <el-button type="primary"
                        @click="generate">上传实验</el-button>
          </div>
          <input ref="file"
                  type="file"
                  style="display:none"
                  accept=".doc, .docx"
                  @change="fileChange">
        </div>
      </div>
    </div>
    </ShowControl>
  </template>
    
    <script>
  import { mapState } from "vuex";
  import FileSaver from "file-saver";
  import htmlDocx from "html-docx-js/dist/html-docx";
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    components: {
      ShowControl
    },
    data () {
      return {
        exportLing: true,
        loading: false,
        caseID: localStorage.getItem("caseId"),
        limitUpload: 1,
        filePath: null,
        TestReport: undefined,
        MarketingData: {},
        DataAnalysis: {},
        ServicesData: {},
        Summary: {},
        MarketingDatas: {},
        DataAnalysiss: {},
        ServicesDatas: {},
        Summarys: {},
        ManagementData: {},
        ManagementDatas: {},
        RounList: [],
        currentPage: 1,
        pagesize: 10,
        ReportExportview: false,
        Experiment: {},
        rounds: {},
        textarea: '',
        checkSummarize: 0,
        flowID: localStorage.getItem("flowID"),
        chatData:null,
        Aievaluate:null,
        Evaluate: '111',
        childTitle: '',
        title: '实验报告',
      };
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
      }),
    },
    created () {
      this.ReportClick(this.$route.query.id)
    },
    mounted () {
      this.$refs.showControl.receiveValue(true);
    },
    methods:
    {
      revertClick(){
        this.$router.go(-1)
      },
      GetStudentStep () {
        this.$http
          .get(
            "StudentData/GetStudentStep?round=" +
            this.rounds
          )
          .then((res) => {
            if (res.success) {
              this.chatData = res.dynamicObj
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      generate()
      {
        this.$confirm("是否上传最终实验报告成绩？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          if(this.chatData==null)
          {
            this.$message.error("请刷新页面重试！");
            return ;
          }
          //this.UploadExperiment();
          this.loading = true
          let row =this.chatData
          var value = "{一、综合评价主要的优点缺点\n"
          +"二、策略优势"
          +"1)xxx(不同指标下的策略优点，例如价格的准确性、市场的相关性，预算合理性等)\n"
          +"2)xxx (列出的优势之二)\n"
          +"3)xxx (列出的优势之三)\n"
          +"三、策略不足\n"
          +"1)xxx(列出对该实验报告的主要关切之一，例如对于价格把握不是很精准，对客人的服务不够重视等)\n"
          +"2)xxx (列出对该文的主要关切之二)\n"
          +"3)xxx (列出对该文的主要关切之三)\n"
          +"四、综合评分（1-10分根据以下数据所得分总和进行打分）\n"
          +"评分:xxx(在这里填写对该篇实验报告的综合评分，10为满分，6为及格线，6之下分数为不及格，可以简要陈述评分的理)\n"
          +"以以上为模板进行评分\n"
          var yuxi=row.filter(c=>c.name =="预习得分")
          value +=`预习得分：${yuxi.length>0 ? yuxi[0].score + "分（完成实验演示操作测试，最低0分，最高5分）。" : "总分5,所得分0"}\n`
          var name1=row.filter(c=>c.name =="会展项目可行性分析")
          value +=`会展项目可行性分析得分：${name1.length>0 ? name1[0].score + "分（根据策划任务完成操作，完成操作得2分，数据提取准确得3分，茶点与正餐数量准确性得1分）。" : "总分5,所得分0"}\n`
          var name2=row.filter(c=>c.name =="会展项目运营策划")
          value +=`会展项目运营策划：${ name2.length>0 ? name2[0].score + "分（其中满足市场行业可得3分、展位数量准确度可得3分、会展场地适宜可得3分、茶点及正餐准确性可得1分）。" :"总分10,所得分0"}\n`
          var name3=row.filter(c=>c.name =="会展项目预算编制")
          value +=`会展项目预算编制：${name3.length>0 ? name3[0].score + "分（编制的预算总额和预算比例与系统预设市场契合度在5%以内得10分，6-15%之间得8分，15-30%之间得6分，大于30%不得分）。" :"总分10,所得分0"}\n`
          var name4=row.filter(c=>c.name =="会展产品价格制定")
          value +=`会展产品价格制定：${name4.length>0 ? name4[0].score + "分（编制大、中、小、门票的价格需符合系统预设市场的占比为3：3：3：1，在 5%以内得10分，6-15%之间得8分，15-30%之间得6分，大于30%不得分）。" : "总分10,所得分0"}\n`
          var name5=row.filter(c=>c.name =="关联企业映射匹配")
          value +=`关联企业映射匹配：${name5.length>0 ? name5[0].score + "分（购买数据与会展策划目标市场匹配度，在5%以内得5分，6-15%之间得4分，15-30%之间得3分，大于30%不得分）。" : "总分5,所得分0"}\n`
          var name6=row.filter(c=>c.name =="会展项目招展邀约")
          value +=`会展项目招展邀约：${name6.length>0 ? name6[0].score + "分（依据市场报告和会展策划目标进行招商，营销精准度，在5%以内得15分，6-15%之间得12分，15-30%之间得9分，大于30%不得分）。" : "总分15,所得分0"}\n`
          var name7=row.filter(c=>c.name =="招商回执动态监测")
          value +=`招商回执动态监测：${name7.length>0 ? name7[0].score + "分（回执名单大于2个，可得1分，否则不得分；已邀约名单大于5个，可得3分，否则不得分）。" : "总分3,所得分0"}\n`
          var name8=row.filter(c=>c.name =="展商服务数字化管理")
          value +=`展商服务数字化管理：${name8.length>0 ? name8[0].score + "分（及时处置完签到、住宿、餐饮、交通、故障等5个环节的问题，2 分/环节；故障未处置，扣4分）。" :"总分10,所得分0"}\n`
          var name9=row.filter(c=>c.name =="展会跟踪及再营销")
          value +=`展会跟踪及再营销：${name9.length>0 ? name9[0].score + "分（在参展商群体中再营销获得客户数大于3个，可得分，否则不得分）。" : "总分5,所得分0"}\n`
          var name10=row.filter(c=>c.name =="会展数字化运营过程复盘")
          value +=`会展数字化运营过程复盘：${name10.length>0 ? name10[0].score + "分（对会展运作状况进行复盘，发放问卷，完成调查参展商反馈，可得2分，完成不同渠道媒体的展后新闻报道，可得2分；完成过程数据分析操作，查看运营过程情况，可得3分；否则不得分）。" : "总分7,所得分0"}\n`
          var name11=row.filter(c=>c.name =="会展数字化运营过程优化")
          value +=`会展数字化运营过程优化：${name11.length>0 ? name11[0].score + "分（查看会展营销、数据、服务、财务等总结报告，可得4分；撰写实验报告并提交可得1分）。" :"总分5,所得分0"}`
          console.log(row)
          console.log(value)
          const xhr = new XMLHttpRequest();
          // 置请求的 URL
          xhr.open('post', this.Global.chaturl + `api/Chat/ChatMSDStream`,true);
          // 设置响应类型为 text/event-stream
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.send(JSON.stringify({"msg": value,"username": 'chenniao_Exhibition_HQDX',"uuid": 'chenniao_Exhibition_HQDX'}));
          // 监听 readyStateChange 事件
          xhr.onreadystatechange = () => {
            if (xhr.readyState == 3) {// 如果 readystate 是 3，表示正在接收数据
              //this.Aievaluate = xhr.responseText
            }
            if (xhr.readyState === 4) {
              if (xhr.status === 200)//避免接受过程中缺少字符
              this.Evaluate=xhr.responseText.replace(/\s+/g, '').trim()
              var data=
              {
                teacherEvaluate:this.Evaluate,
                round:this.rounds,
                score: this.Experiment.teacherRating,
                totalScore: this.Experiment.newtotalScore
              }
              this.Experiment.teacherRating= this.Experiment.aiScores
              // this.Experiment.score= this.Experiment.newSetpScore
              this.Experiment.totalScore= this.Experiment.newtotalScore
              data.score= this.Experiment.aiScore
              this.$http.post("StudentData/UpdateTranscript",data)
                .then((res) => {
                  if (res.success) {
                    this.UploadExperiment();
                  }else{
                    this.loading = false
                    return this.$message.error(res.message);
                  } 
                });
            }
          }
        })
          .catch((error) => {
            console.log(error);
          });
      },
      handleSizeChangeType: function (size) {
        this.pagesize = size;
      },
      //当前页码
      handleCurrentChangeType: function (currentPage) {
        this.currentPage = currentPage;
      },
      ReportClick (id) {
        this.childTitle= '实验报告'
        let username = localStorage.getItem("ms_username");
        let expID = localStorage.getItem("expID");
        this.rounds = parseInt(id);
        this.$http.get(`Summarize/GetTestReport?round=${this.rounds}&userName=${username}&expId=${expID}`).then((res) => {
          if (res.success) {
            this.loading = true;
            this.Experiment = res.dynamicObj
            if (this.flowID == this.Global.FlowList.实验总结) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              if ((that.$store.state.user.checkSummarize & (1 << 0)) == 0) {
                checkSummarize += 1;
                this.checkSummarize = checkSummarize;
                that.$store.commit("checkSummarizecomit", checkSummarize);
              }
            }
            this.GetExhibitionMarketingData();
            this.GetStudentStep();
          } else {
            this.loading = false;
            return this.$message.error(res.message)
          }
        })
      },
      UploadExperiment () {
        this.$nextTick((_) => {
          console.log(_)
          let str = '';
          let dom = document.querySelector(".drawerDiv");
          dom.children.forEach(item => {
            if (item.id && item.id.indexOf("columnChart") > -1) {
              let columnChart = this.echarts.init(item);
              let baseUrl = columnChart.getDataURL({ pixelRatio: 2 });
              str += `<div align="center" style="text-align:center;width:100%"><img src="${baseUrl}" width="623" height="300" /></div>`;
            } else { str += item.outerHTML; }
          })
          let content = `
            <!DOCTYPE html><html>
                  <head>
                      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                  </head>
                  <body>
                      <table>
                          ${str}
                      </table>
                      <p>实验总结：${this.textarea}</p>
                  </body>
                </html>`;
          let converted = htmlDocx.asBlob(content);
          let formData = new FormData();
          formData.append('file', converted, '实验报告.docx');
          this.$http
            .post(
              "Upload/UploadExportReport", formData)
            .then((res) => {
              if (res.success) {
                this.filePath = res.dynamicObj;
                this.InsertExperimentReport();
                this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.实验报告上传 }); 
                this.API.createTaskBar(this.Round, this.Global.EnumUserStatus.normal, '上传实验');
                this.loading=false;
                //this.generate();
              } else {
                return this.$message.error(res.message);
              }
            });
        })
      },
      ExportReport () {
        this.$nextTick((_) => {
          console.log(_)
          let str = '';
          let dom = document.querySelector(".drawerDiv");
          dom.children.forEach(item => {
            if (item.id && item.id.indexOf("columnChart") > -1) {
              let columnChart = this.echarts.init(item);
              let baseUrl = columnChart.getDataURL({ pixelRatio: 2 });
              str += `<div align="center" style="text-align:center;width:100%"><img src="${baseUrl}" width="623" height="300" /></div>`;
            } else { str += item.outerHTML; }
          })
          let content = `
            <!DOCTYPE html><html>
                  <head>
                      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                  </head>
                  <body>
                      <table>
                          ${str}
                      </table>
                      <span>实验总结：${this.textarea}</span>
                  </body>
                </html>`;
          let converted = htmlDocx.asBlob(content);
          FileSaver.saveAs(converted, "实验报告.docx");
        })
      },
      InsertExperimentReport () {
        var data=
        {
          round:this.rounds,
          filePath:this.filePath,
          evaluate:this.Evaluate,
        }
        if(this.Experiment.teacherRating==0)
        {
          data.aiScore= this.Experiment.aiScore
        }
        this.$http.post("ExperimentReport/InsertExperimentReport",data)
        .then((res) => {
            if (res.success) {
              this.Global.sendmsgmd(
                "项目管理",
                `上传了实验报告`,
                1
              );
              let expid= localStorage.getItem("expID");
              let accessToken= localStorage.getItem("access_tokenExp");
              let un= localStorage.getItem("ms_username");
              let create_time= localStorage.getItem("create_time");
              if(accessToken!= "undefined" && accessToken!= null)
              {
                var parm =
                 {
                  Access_token : accessToken,
                  Round : this.rounds,
                  un : un,
                  create_time : create_time,
                  Expid:parseInt(expid)
                }
                this.$http.post("User/GetAATest",parm)
                .then((res) => {
                  if (res.code == 0) {
                    console.log(res.dynamicObj)
                  } else {
                    return this.$message.error("实验空间上传失败"+ res.msg);
                  }
                });
              }
              this.$message.success('实验上传成功！');
              this.GetExhibitionMarketingData()
            } else {
              this.GetExhibitionMarketingData()
              return this.$message.error(res.message);
            }
          });
      },
      GetTestReport () {
        this.$http
          .get(
            "ExperimentReport/GetTestReport?round=" +
            this.rounds
          )
          .then((res) => {
            if (res.success) {
              this.TestReport = res.dynamicObj
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      GetExhibitionMarketingData () {
        this.exportLing = true;
        this.$nextTick(_ => {
          console.log(_)
          var chartDom = document.getElementById('columnChart_chartSG1');
          var myChart = this.echarts.init(chartDom);
          var option;
          this.$http
            .get(
              "StudentData/GetExhibitionMarketingData?round=" +
              this.rounds + "&caseID=" + this.caseID
            )
            .then((res) => {
              if (res.success) {
                this.MarketingDatas = res.dynamicObj;
                this.MarketingData = res.dynamicObj.result;
                option = {
                  backgroundColor: '#fff',
                  title: {
                    subtext: '会展营销总结',
                    left: 'center',
                    top: -10
                  },
                  series: [
                    {
                      type: 'sankey',
                      data: this.MarketingDatas.data,
                      links: this.MarketingDatas.link,
                      emphasis: {
                        focus: 'adjacency'
                      },
                      lineStyle: {
                        color: 'gradient',
                        curveness: 0.5
                      }
                    }
                  ],
                  tooltip: {
                    trigger: 'item',
                    triggerOn: 'mousemove'
                  }
                };
                option && myChart.setOption(option);
                this.GetDataAnalysis();
              } else {
                return this.$message.error(res.message);
              }
            });
        })
      },
      GetDataAnalysis () {
        var chartDom = document.getElementById('columnChart_chartSG2');
        var myChart = this.echarts.init(chartDom);
        var option;
        this.$http
          .get(
            "Summarize/GetDataAnalysis?round=" +
            this.rounds + "&caseID=" + this.caseID
          )
          .then((res) => {
            if (res.success) {
              this.DataAnalysiss = res.dynamicObj;
              this.DataAnalysis = res.dynamicObj.result;
              option = {
                backgroundColor: '#fff',
                title: {
                  subtext: '数据分析总结',
                  left: 'center',
                  top: -10
                },
                series: [
                  {
                    type: 'sankey',
                    data: this.DataAnalysiss.data,
                    links: this.DataAnalysiss.link,
                    emphasis: {
                      focus: 'adjacency'
                    },
                    lineStyle: {
                      color: 'gradient',
                      curveness: 0.5
                    }
                  }
                ],
                tooltip: {
                  trigger: 'item',
                  triggerOn: 'mousemove'
                }
              };
              option && myChart.setOption(option);
              this.GetServicesData();
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      GetServicesData () {
        var chartDom = document.getElementById('columnChart_chartSG3');
        var myChart = this.echarts.init(chartDom);
        var option;
        this.$http
          .get(
            "StudentData/GetExhibitionServicesData?round=" +
            this.rounds + "&caseID=" + this.caseID
          )
          .then((res) => {
            if (res.success) {
              this.ServicesDatas = res.dynamicObj;
              this.ServicesData = res.dynamicObj.result;
              option = {
                backgroundColor: '#fff',
                title: {
                  subtext: '会展服务总结',
                  left: 'center',
                  top: -10
                },
                series: [
                  {
                    type: 'sankey',
                    data: this.ServicesDatas.data,
                    links: this.ServicesDatas.link,
                    emphasis: {
                      focus: 'adjacency'
                    },
                    lineStyle: {
                      color: 'gradient',
                      curveness: 0.5
                    }
                  }
                ],
                tooltip: {
                  trigger: 'item',
                  triggerOn: 'mousemove'
                }
              };
              option && myChart.setOption(option);
              this.GetFinancialSummary();
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      GetFinancialSummary () {
        var chartDom = document.getElementById('columnChart_chartSG4');
        var myChart = this.echarts.init(chartDom);
        var option;
        this.$http.get(`FinanceStatistics/GetFinancialSummary?round=${this.rounds}`).then((res) => {
          if (res.success) {
            this.Summarys = res.dynamicObj
            this.Summary = res.dynamicObj.result;
            option = {
              backgroundColor: '#fff',
              title: {
                subtext: '会展财务总结',
                left: 'center',
                top: -10
              },
              series: [
                {
                  type: 'sankey',
                  data: this.Summarys.data,
                  links: this.Summarys.link,
                  emphasis: {
                    focus: 'adjacency'
                  },
                  lineStyle: {
                    color: 'gradient',
                    curveness: 0.5
                  }
                }
              ],
              tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove'
              }
            };
            option && myChart.setOption(option);
            this.GetManagementData();
          } else {
            this.$message.console.error(res.message);
          }
        })
      },
      GetManagementData () {
        this.$nextTick(_ => {
          console.log(_)
          var chartDom = document.getElementById('columnChart_chartSG');
          var myChart = this.echarts.init(chartDom);
          var option;
          this.$http.get(`StudentData/GetManagementData?round=${this.rounds}`).then((res) => {
            if (res.success) {
              this.ManagementDatas = res.dynamicObj
              this.ManagementData = res.dynamicObj.result;
              option = {
                backgroundColor: '#fff',
                title: {
                  subtext: '项目管理总结',
                  left: 'center',
                  top: -10
                },
                series: [
                  {
                    type: 'sankey',
                    data: this.ManagementDatas.data,
                    links: this.ManagementDatas.link,
                    emphasis: {
                      focus: 'adjacency'
                    },
                    lineStyle: {
                      color: 'gradient',
                      curveness: 0.5
                    }
                  }
                ],
                tooltip: {
                  trigger: 'item',
                  triggerOn: 'mousemove'
                }
              };
              option && myChart.setOption(option);
              this.loading = false;
            } else {
              this.$message.console.error(res.message);
            }
          })
        })
      },
    },
    watch: {
      checkSummarize (newVal, oldVal) {
        if (newVal == 31) {
          if (this.flowID == this.Global.FlowList.实验总结) {
            this.$http.get(`User/SummarizeScore?round=${this.Round}`).then((res) => {
              if (res.success) {
                let that = this;
                let checkSummarize = that.$store.state.user.checkSummarize;
                checkSummarize += 1;
                this.checkSummarize = checkSummarize;
                that.$store.commit("checkSummarizecomit", checkSummarize);
              }
            })
          }
        } else {
          console.log(oldVal)
        }
      }
    }
  }
    </script>
    
    <style   scoped>
  .span {
    color: red;
    font-size: 15px;
    font-weight: 600;
  }
  .drawerDiv {
    height: 100%;
  }
  #columnChart_chartSG {
    width: 900px;
    height: 490px;
    color: white;
    margin-top: 10px;
  }
  #columnChart_chartSG1 {
    width: 900px;
    height: 490px;
    color: white;
    margin-top: 10px;
  }
  #columnChart_chartSG2 {
    width: 900px;
    height: 490px;
    color: white;
    margin-top: 10px;
  }
  #columnChart_chartSG3 {
    width: 900px;
    height: 490px;
    color: white;
    margin-top: 10px;
  }
  #columnChart_chartSG4 {
    width: 900px;
    height: 490px;
    color: white;
    margin-top: 10px;
  }
  </style>